import React from "react";
import { Upload, Form, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { uploadFileApi } from "../../../api/ManageApi";

const UploadImageFormItem = (props: {
  name: any;
  label: string;
  form: any;
}) => {

  return <Form.Item noStyle shouldUpdate>
    {() => {
      const fileData = (props.form.getFieldValue('upload') || {})[props.name];
      return <Form.Item
        name={["upload", props.name]}
        label={props.label}
        valuePropName={'file'}
        getValueFromEvent={(e:any) => {
          return e && e.file
        }}
      >
        <Upload
          customRequest={async(options: any) => {
            const { onSuccess, onError, file } = options
            const upload_response = await uploadFileApi({file: file, type: 'banner'})
            if (upload_response.status) {
              file.url = upload_response?.data?.url
              onSuccess && onSuccess(file)
            } else {
              message.error( upload_response.error )
              onError && onError({message: upload_response.error, name: 'error'})
            }
          }}
          fileList={!!fileData && fileData?.status !== 'removed' ? [fileData] : []}
          listType="picture-card"
          maxCount={1}
          accept={'image/*'}>
          {
            (!fileData || fileData?.status === 'removed') && <button style={{ border: 0, background: 'none' }} type="button">
              <PlusOutlined />
              <div style={{ marginTop: 8 }}>上传</div>
            </button>
          }
        </Upload>
      </Form.Item>
    }}
  </Form.Item>;
};

export default UploadImageFormItem;